import {
  setActiveTg,
  setDataTg,
  setErrorTg,
  setLoadingTg,
  setUpdateTg,
} from "../../../../store/slices/integrationSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

// Инит тг
export const sendUserId = (
  userData,
  setStep,
  setLoading,
  setIsTelegramConnected,
  setError
) => {
  return (dispatch) => {
    setLoading(true); // Включаем загрузку

    const storedType = localStorage.getItem("typeTelegramInit");
    const isFirstInit = !storedType;

    const requestData = {
      userId: userData.userId,
      clientIdentifier: userData.clientIdentifier,
      type: isFirstInit ? "" : storedType || userData.type || "",
      value: userData.value || "",
    };

    // Отправляем запрос на сервер
    $authHost
      .post(`/integrations/telegram/initialization`, requestData)
      .then((response) => {
        const { expectedType, code, message } = response.data;

        if (
          code === 200 &&
          message === "initialization complited" &&
          expectedType === ""
        ) {
          setIsTelegramConnected(true);
          dispatch(getTelegramIntegrations(userData.userId));
          setLoading(false);
          return;
        }

        if (expectedType === "phone") {
          const phoneData = {
            userId: userData.userId,
            clientIdentifier: userData.clientIdentifier,
            type: "phone",
            value: userData.clientIdentifier,
          };

          $authHost
            .post(`/integrations/telegram/initialization`, phoneData)
            .then((phoneResponse) => {
              const { expectedType: nextExpectedType } = phoneResponse.data;

              localStorage.setItem("typeTelegramInit", nextExpectedType);

              if (nextExpectedType) {
                switch (nextExpectedType) {
                  case "code":
                    setStep(2);
                    break;
                  case "password":
                    setStep(3);
                    break;
                  default:
                    console.error(
                      "Unexpected nextExpectedType:",
                      nextExpectedType
                    );
                }
              }
            })
            .catch((error) => {
              console.error(
                "Error sending phone:",
                error.response?.data?.message || error.message
              );
              handleErrors(error, setError);
            })
            .finally(() => setLoading(false));
        } else {
          if (expectedType) {
            localStorage.setItem("typeTelegramInit", expectedType);

            switch (expectedType) {
              case "code":
                setStep(2);
                break;
              case "password":
                setStep(3);
                break;
              default:
                console.error("Unexpected expectedType:", expectedType);
            }
          }
        }

        if (message) {
          handleErrorMessages(message, setError);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            dispatch(removeUser());
          } else if (error.response.status === 500) {
            setError("Ошибка сервера. Попробуйте позже.");
          }
        } else if (error.request) {
          setError("Проблемы с подключением. Проверьте интернет.");
        } else {
          setError("Произошла неизвестная ошибка.");
        }

        console.error(
          "Error in sendUserId:",
          error.response?.data?.message || error.message
        );
        setLoading(false);
      });
  };
};
// Функция для обработки сообщений об ошибках
const handleErrorMessages = (message, setError) => {
  if (message === "incorrect code") {
    setError("Неверный код, повторите попытку");
  }
  if (message === "incorrect phone") {
    setError("Ошибка Telegram, повторите попытку позже");
  }
  if (message === "incorrect password") {
    setError("Неверный пароль, повторите попытку");
  }
};
// Функция для обработки ошибок
const handleErrors = (error, setError) => {
  const errorMessage = error.response?.data?.message;

  if (errorMessage === "incorrect type") {
    localStorage.setItem(
      "typeTelegramInit",
      error.response?.data?.expectedType
    );
  }
  if (errorMessage === "incorrect code") {
    setError("Неверный код, повторите попытку");
  }
  if (errorMessage === "incorrect phone") {
    setError("Ошибка Telegram, повторите попытку позже");
  }
  if (errorMessage === "incorrect password") {
    setError("Неверный пароль, повторите попытку");
  }
};

// Получение списка телеграм аккаунтов
export const getTelegramIntegrations = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/telegram/list?userId=${userId}`
      );

      if (data.code === 200) {
        dispatch(setDataTg(data.users));
      } else {
        errorToast("Ошибка:", data.code);
        console.error(`Unexpected response code: ${data.code}`, data);
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (status === 404) {
          console.error("Данные не найдены:", data.message || "Not Found");
        } else if (status === 500) {
          console.error(
            "Ошибка сервера:",
            data.message || "Internal Server Error"
          );
        }
      } else if (error.request) {
        console.error("Нет ответа от сервера. Проверьте интернет-соединение.");
      } else {
        console.error("Произошла неизвестная ошибка:", error.message);
      }
    }
  };
};

// Получение конкретной интеграции тг (добавить скрытие контента за надписью ошибки)
export const getTelegramIntegration = (userId, externalTelegramId) => {
  return async (dispatch) => {
    dispatch(setErrorTg(false));
    dispatch(setLoadingTg(true));

    try {
      const { data } = await $authHost.get(
        `/integrations/telegram?userId=${userId}&externalTelegramId=${externalTelegramId}`
      );

      if (data.code === 200) {
        dispatch(setLoadingTg(false));
        localStorage.setItem("dataTg", JSON.stringify(data.user));
        dispatch(setActiveTg(data.user));
      } else {
        errorToast(`Ошибка: ${data.code || "Неизвестная ошибка"}`);
      }
    } catch (error) {
      dispatch(setErrorTg(true));
      dispatch(setLoadingTg(false));

      if (error.response) {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("error get tg integration", error);
    }
  };
};

// Обновление тг
export const configureTelegramClient = (configuration, externalTelegramId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/telegram/client`,
        configuration
      );

      if (data.code === 200) {
        dispatch(getTelegramIntegration(userId, externalTelegramId));
        dispatch(setUpdateTg(false));
      } else {
        errorToast(`Ошибка: ${data.code || "Неизвестная ошибка"}`);
      }
    } catch (error) {
      if (error.response) {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
          errorToast("Не авторизован. Пожалуйста, войдите снова.");
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }
      console.log("configureTelegramClient error:", error);
    }
  };
};

// Деактивация тг
export const deactivateTelegram = (dataDeactivation, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);

    try {
      const { data } = await $authHost.post(
        `/integrations/telegram/deactivation`,
        dataDeactivation
      );

      if (data.code === 200) {
        localStorage.removeItem("dataTg");
        setLoading(false);
        dispatch(setActiveTg(null));
        dispatch(getTelegramIntegrations(dataDeactivation.userId));
        navigate("/integration");
      } else {
        errorToast(
          `Ошибка деактивации. Попробуйте снова. Код ошибки: ${data.code}`
        );
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (data.message === "error: client not found") {
          dispatch(getTelegramIntegrations(userId));
          errorToast("Ошибка деактивации. Клиент не найден");
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("deactivateTelegram error:", error);
    }
  };
};
